import { Navigate, useTypedParams } from '@sorare/routing';
import {
  ANY_SPORT_PLAY_BOARDS,
  ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_LINEUPS,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useEnableSorare27Nav } from '@sorare/core/src/hooks/useEnableSorare27Nav.ts';

import type { PageParams } from './__generated__/routeParams.ts';

const PlayProFixturePage = () => {
  const enableSorare27Nav = useEnableSorare27Nav();
  const { generateSportContextPath } = useSportContext();
  const { fixture, eventType } = useTypedParams<PageParams>();

  if (enableSorare27Nav) {
    return (
      <Navigate
        to={generateSportContextPath(ANY_SPORT_PLAY_BOARDS, {
          params: {
            fixture,
            eventType,
          },
        })}
        replace
        keepSearchParams
      />
    );
  }

  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_LINEUPS, {
        params: {
          fixture,
          eventType,
        },
      })}
      replace
    />
  );
};

export default PlayProFixturePage;
